export const MODULE = 'machinery/tax_credit';
export const GET_LIST = `${MODULE}/get_list`;
export const SHOW_DATA = `${MODULE}/show_data`;
export const UPDATE_DATA = `${MODULE}/update_data`;
export const VALIDATE_APPLICATION = `${MODULE}/validate_application`;
export const GET_TAX_CREDIT_LOGS = `${MODULE}/get_tax_credit_logs`;
export const VALIDATE_APPLICATION_TRANSFER = `${MODULE}/validate_application_transfer`;
export const TRANSFER_TAX_CREDIT = `${MODULE}/transfer_tax_credit`;
export const CREATE_DATA = `${MODULE}/create_data`;
export const REMOVE_DATA = `${MODULE}/remove_data`;
export const GET_ADMIN_MODULE = 'ADMIN_MODULE/get_admin_module';

export const TRANSACTION_TYPE = [
  { label: 'CREDIT', value: 'CREDIT' },
  { label: 'REDUCE', value: 'REDUCE' },
];

export const FORM_DATA = {
  name: '',
};
